import React from 'react';
import { DatePicker as _DatePicker } from '@material-ui/pickers';
import _GeneralDialog from '../../../internal-components/GeneralDialog';
import Input from '@material-ui/core/Input';
import styled from 'styled-components/macro';
import { FormControlLabel, MenuItem, Tooltip } from '@material-ui/core';
import _UsersInputBoxEngine from '../../engine/UsersInputBoxEngine';
import moment from '../../../utils/momentWithLocale';
import InputBase from '../../form/InputBase';
import FileUploadEngine from '../../engine/FileUploadEngine';
import parseDate from '../../../utils/parseDate';
import MuiSelect from '@material-ui/core/Select';

const GeneralDialog = styled(_GeneralDialog)`
  [class*='MuiDialogContent-root'] {
    padding-top: 0 !important;
  }
`;

const ControlContainer = styled.div`
  && {
    width: 650px;
  }
`;

const StyledInput = styled(Input)`
  && {
    background-color: #fff;
    border: 1px solid #bfc5d1;
    border-radius: 5px;
    box-sizing: border-box;
    font-size: 14px;
    font-weight: 500;
    height: 36px;
    margin: 0 0 20px;
    padding: 17px;
    width: 650px;
  }
`;

const StyledMultilineInput = styled(Input)`
  && {
    background-color: #fff;
    border: 1px solid #bfc5d1;
    border-radius: 5px;
    box-sizing: border-box;
    font-size: 14px;
    font-weight: 500;
    margin: 0 0 20px;
    padding: 17px;
    padding-left: 17px;
    width: 650px;
  }
`;

const ControlLabel = styled(FormControlLabel)`
  && {
    align-items: start;
    margin-left: 0;
  }
`;

const UsersInputBoxEngine = styled(_UsersInputBoxEngine)`
  && {
    margin-bottom: 20px;
    width: 650px;
  }
`;

const Select = props => (
  <MuiSelect
    variant="outlined"
    inputProps={{ placeholder: 'Please choose an option.' }}
    // input={<OutlinedInput placeholder="Please choose an option." />}
    {...props}
  />
);

const PrioritySelect = styled(Select)`
  && {
    margin-bottom: 20px;
  }
  [class*='MuiSelect-root'] {
    padding: 3px;
    width: 12rem;
  }
`;

const DatePicker = styled(_DatePicker)`
  && {
    margin-bottom: 20px;
  }
`;

const FileUploadContainer = styled.div`
  && {
    margin-top: -35px;
  }
  [class*='FileUploadView__Container'] {
    width: 100%;
  }
`;

const AttachmentsLabel = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 19.5px;
  margin: 0.5rem 0;
`;

const MaximumSizeLabel = styled.span`
  font-weight: 400;
`;

const FieldTitle = styled.span`
  ${({ $required }) =>
    $required &&
    `&:after {
      content:" *";
      color: red;
      }`}
`;

const UnsavedChangesWarningDialog = GeneralDialog;

const AddTaskDialogView = props => {
  return (
    <>
      <GeneralDialog {...props} title="Add a task">
        <ControlContainer>
          <ControlLabel
            label={
              <Tooltip title="This field is required">
                <FieldTitle $required>Task title</FieldTitle>
              </Tooltip>
            }
            labelPlacement="top"
            control={
              <StyledInput
                inputProps={{
                  'data-testid': 'task_title'
                }}
                type="text"
                disableUnderline={true}
                onChange={props.onChangeTaskTitle}
                value={props.taskTitle}
              />
            }
          />
        </ControlContainer>
        <ControlContainer>
          <ControlLabel
            label="Task description"
            labelPlacement="top"
            control={
              <StyledMultilineInput
                inputProps={{
                  'data-testid': 'task_description',
                  rows: 5
                }}
                type="text"
                multiline
                disableUnderline={true}
                onChange={props.onChangeTaskDescription}
                value={props.taskDescription}
              />
            }
          />
        </ControlContainer>
        <ControlContainer>
          <ControlLabel
            label={
              <Tooltip title="This field is required">
                <FieldTitle $required>Assign a user</FieldTitle>
              </Tooltip>
            }
            labelPlacement="top"
            control={
              <UsersInputBoxEngine
                isMulti={false}
                value={props.selectedUser}
                onChange={props.onChangeSelectedUser}
              />
            }
          />
        </ControlContainer>
        <ControlContainer>
          <ControlLabel
            label={
              <Tooltip title="This field is required">
                <FieldTitle $required>Due date</FieldTitle>
              </Tooltip>
            }
            labelPlacement="top"
            control={
              <DatePicker
                autoOk
                TextFieldComponent={InputBase}
                format={moment.localeData().longDateFormat('L')}
                value={props.taskDueDate ? parseDate(props.taskDueDate) : null}
                emptyLabel="Select date"
                onChange={props.onChangeDate}
              />
            }
          />
        </ControlContainer>
        <ControlContainer>
          <ControlLabel
            label="Priority"
            labelPlacement="top"
            control={
              <PrioritySelect
                // options={props.priorityOptions}
                value={props.priority}
                onChange={props.onChangePriority}
              >
                {props.priorityOptions.map(one => {
                  return <MenuItem value={one.value}>{one.text}</MenuItem>;
                })}
              </PrioritySelect>
            }
          />
        </ControlContainer>
        <ControlContainer>
          <AttachmentsLabel>
            Upload attachment{' '}
            <MaximumSizeLabel>(Maxiumum size: 2 MB)</MaximumSizeLabel>
          </AttachmentsLabel>
          <FileUploadContainer>
            <FileUploadEngine
              key={'file-count' + props.existingFiles.length}
              onFileDropped={props.onFileDropped}
              existingFiles={props.existingFiles}
            />
          </FileUploadContainer>
        </ControlContainer>
      </GeneralDialog>
      <UnsavedChangesWarningDialog
        open={props.isUnsavedChangesWarningDialogOpen}
        handleConfirm={props.onConfirmLoseChangesDialog}
        handleClose={() => props.setIsUnsavedChangesWarningDialogOpen(false)}
        title="dialog.title.areYouSure"
        content="entries.entry.dialog.loseChanges.text"
      />
    </>
  );
};

export default AddTaskDialogView;
